import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import React from "react";

export const TooltipCustom = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black, 
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black, 
      color: theme.palette.common.white, 
      fontSize: '0.875rem',
    },
  }));